import { makeStyles } from '@mui/styles';
import { colors, typography as typographyTokens, radii } from '@components/design-system/tokens';

export const useStyles = makeStyles((theme: any) => ({
    userInfo: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        marginLeft: 'auto',
        padding: '6px 8px',
        borderRadius: `${radii.md}px`,
        transition: 'background-color 150ms ease',

        '&:hover': {
            backgroundColor: colors.neutral[100],
        },

        '& p': {
            margin: '0 8px',
            fontSize: typographyTokens.fontSize.sm,
            fontWeight: typographyTokens.fontWeight.medium,
            color: colors.neutral[700],

            [theme.breakpoints.down('md')]: {
                margin: '0 6px',
                fontSize: typographyTokens.fontSize.sm,
            },
        },
    },
    rounded: {
        color: colors.neutral[0],
        backgroundColor: colors.primary[500],
        fontSize: typographyTokens.fontSize.sm,
        fontWeight: typographyTokens.fontWeight.semibold,
        width: 36,
        height: 36,
        [theme.breakpoints.down('md')]: {
            width: 32,
            height: 32,
        },
    },
    downIcon: {
        color: colors.neutral[400],
        padding: 4,
        
        '& svg': {
            fontSize: 20,
        },
    },
}));
